<!-- src/views/project/ReservationsCalendar.vue -->
<template>
  <v-card
    :style="cardStyle"
    class="rounded-xl"
  >
    <v-card-title class="d-flex align-center">
      {{ $t("Calendrier des réservations") }}
      <v-spacer />
      <v-btn
        icon
        @click="fetchEvents"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>

    <!-- Barre de navigation et sélection de la vue -->
    <v-toolbar
      flat
      dense
    >
      <v-btn
        icon
        @click="prev"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <v-btn
        text
        @click="today"
      >
        {{ $t("Aujourd'hui") }}
      </v-btn>

      <v-btn
        icon
        @click="next"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>

      <v-spacer />

      <v-select
        :items="viewTypes"
        v-model="viewType"
        item-text="text"
        item-value="value"
        dense
        hide-details
        outlined
        style="max-width: 140px"
      />
    </v-toolbar>

    <v-card-text
      class="pa-0"
      style="height: 650px"
    >
      <v-sheet
        tile
        height="100%"
      >
        <v-calendar
          v-model="viewStart"
          :type="viewType"
          :events="events"
          locale="fr"
          event-overlap-mode="stack"
          @click:event="onEventClick"
          style="height: 100%"
        >
          <template #event="{ event }">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <div
                  class="calendar-event-chip"
                  v-bind="attrs"
                  v-on="on"
                  :style="{ backgroundColor: event.color }"
                >
                  {{ event.name }}
                </div>
              </template>
              <pre class="ma-0">{{ event.tooltip }}</pre>
            </v-tooltip>
          </template>
        </v-calendar>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<script>
import { ReservationService } from "@/services"
import { getTheme } from "@/plugins/vuetify"
export default {
  name: "ReservationsCalendar",
  data() {
    return {
      events: [],
      // Date de début affichée ("YYYY-MM-DD")
      viewStart: new Date().toISOString().substr(0, 10),
      // Type de vue actuel
      viewType: "month",
      // Options pour le sélecteur de vue
      viewTypes: [
        { text: "Mois", value: "month" },
        { text: "Semaine", value: "week" },
        { text: "Jour", value: "day" }
      ],
      // Palette de couleurs vives pour les événements
      colorPalette: [
        "#E53935", // rouge
        "#8E24AA", // violet
        "#3949AB", // indigo
        "#039BE5", // bleu ciel
        "#43A047", // vert
        "#FDD835", // jaune
        "#FB8C00", // orange
        "#D81B60" // rose vif
      ]
    }
  },
  computed: {
    project() {
      return this.$store.state.app.project
    },
    cardStyle() {
      return { backgroundColor: getTheme(this).bgCard }
    }
  },
  methods: {
    // Formate une Date en "YYYY-MM-DD hh:mm"
    formatForCalendar(d) {
      const pad = n => String(n).padStart(2, "0")
      return (
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}`
      )
    },

    // Récupère les réservations et les transforme en événements
    async fetchEvents() {
      const resp = await ReservationService.getCalendar(this, this.project.id)
      this.events = resp.results.map((r, i) => {
        const start = new Date(r.start)
        const end = new Date(r.end)
        return {
          id: r.id,
          name: r.title,
          start: this.formatForCalendar(start),
          end: this.formatForCalendar(end),
          timed: true,
          tooltip: r.tooltip[0],
          // Affectation cyclique d'une couleur vive
          color: this.colorPalette[i % this.colorPalette.length]
        }
      })
    },

    // Naviguer à la période précédente
    prev() {
      const date = new Date(this.viewStart)
      if (this.viewType === "month") {
        date.setMonth(date.getMonth() - 1)
      } else if (this.viewType === "week") {
        date.setDate(date.getDate() - 7)
      } else {
        date.setDate(date.getDate() - 1)
      }
      this.viewStart = date.toISOString().substr(0, 10)
    },

    // Naviguer à la période suivante
    next() {
      const date = new Date(this.viewStart)
      if (this.viewType === "month") {
        date.setMonth(date.getMonth() + 1)
      } else if (this.viewType === "week") {
        date.setDate(date.getDate() + 7)
      } else {
        date.setDate(date.getDate() + 1)
      }
      this.viewStart = date.toISOString().substr(0, 10)
    },

    // Revenir à aujourd'hui
    today() {
      this.viewStart = new Date().toISOString().substr(0, 10)
    },
    formatPrice(v) {
      return v == null
        ? ""
        : new Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(v)
    },

    // Gestion du clic sur un événement
    onEventClick({ event }) {
      this.$router.push({
        name: "ReservationCreateUpdate",
        params: { id: event.id }
      })
    }
  },
  mounted() {
    this.fetchEvents()
  }
}
</script>

<style scoped>
.calendar-event-chip {
  padding: 4px 8px;
  font-size: 0.75rem;
  border-radius: 4px;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-sheet {
  padding: 0 !important;
}
</style>
